export const getNutSeedButtersPackage = newProduct => {
  let newNutSeedButtersPackage = {
    UPC: newProduct.UPC,
    Iron: newProduct.Iron,
    Protein: newProduct.Protein,
    Texture: newProduct.Texture,
    Size: newProduct.Size,
    Type: newProduct.Type,
  }

  if (newProduct.Texture === 'Other') {
    newNutSeedButtersPackage.OtherTexture = newProduct.OtherTexture
  }

  return newNutSeedButtersPackage
}

export const updateNutSeedButtersPackage = newProduct => {
  let newNutSeedButtersPackage = {
    UPC: newProduct.UPC,
    Iron: newProduct.Iron,
    Protein: newProduct.Protein,
    Texture: newProduct.Texture,
    Size: newProduct.Size,
    Type: newProduct.Type,
  }

  if (newProduct.Texture === 'Other') {
    newNutSeedButtersPackage.OtherTexture = newProduct.OtherTexture
  }

  return newNutSeedButtersPackage
}
